export default function Yup (u, p) {
  const he = {
    'preeti': 'potato',
    'guest1': 'Only1',
    'notguest': 'adminpassword'
  }
  let data = {
    guest: false,
    access: false
  }

  if (he[u]) {
    if (he[u] === p) {
      data.guest = !!(he[u] === 'Only1');
      data.access = true;
    }
  }

  return data;
}


// WEBPACK FOOTER //
// ./src/const.js